var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 667,
    viewBox: "0 0 667 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 333.5,
    cy: 333.5,
    r: 333.5,
    fill: "url(#paint0_linear_250_2047)",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.5,
    cy: 333.5,
    r: 333,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.498,
    cy: 333.5,
    r: 278.264,
    fill: "url(#paint1_linear_250_2047)",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.498,
    cy: 333.5,
    r: 277.764,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.498,
    cy: 333.5,
    r: 168.834,
    fill: "url(#paint2_linear_250_2047)",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.498,
    cy: 333.5,
    r: 168.334,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.499,
    cy: 333.5,
    r: 107.866,
    fill: "url(#paint3_linear_250_2047)",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.499,
    cy: 333.5,
    r: 107.366,
    stroke: "white",
    strokeOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_2047",
    x1: 333.5,
    y1: 0,
    x2: 333.5,
    y2: 667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_2047",
    x1: 333.498,
    y1: 55.2363,
    x2: 333.498,
    y2: 611.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_250_2047",
    x1: 333.498,
    y1: 164.666,
    x2: 333.498,
    y2: 502.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_250_2047",
    x1: 333.499,
    y1: 225.634,
    x2: 333.499,
    y2: 441.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepBackground);
export default __webpack_public_path__ + "static/media/Step-Background.d20cc6c5b2746bf77048e625ca9e1e63.svg";
export { ForwardRef as ReactComponent };